/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable react/react-in-jsx-scope */
import {
  useState, useMemo, useEffect, useCallback,
} from 'react';
import {
  Tooltip, useMantineColorScheme, Modal, Loader,
} from '@mantine/core';
import { useClickOutside } from '@mantine/hooks';
import {
  Plus, X, AlertTriangle, Trash, Check,
} from 'tabler-icons-react';
import {
  renderNumber, renderCompactNumber, displayDate,
} from '../../../utilities/general';
import AlertIcon from '../../../components/CommonFunction/AlertIcon';
import styles from './AddEntryPriceModal.module.css';

// Utils
const fixValOfCost = (num) => Number((num + Number.EPSILON).toFixed(4));
const mapRawEntries = (raw = []) => {
  const flattened = Array.isArray(raw) ? raw.flat(Infinity) : [];
  return flattened.map((e, i) => ({
    isNew: false,
    quantity: Number(e.quantity),
    price: Number(e.price),
    // totalCost: (Number(e.quantity) * Number(e.price)).toFixed(3),
    totalCost: fixValOfCost(e?.quantity * e?.price),
    // totalCost: fixValOfCost(e.quantity * e.price),
    timestamp: e.timestamp,
  }));
};

// Heading
const HeaderSection = ({
  tokenName, totalQuantity, colorScheme, onClose,
}) => (
  <div
    className="flex h-full px-9 py-4 justify-between items-start self-stretch border-b border-[#E5E7EB] dark:border-[#898989] rounded-t-2xl"
  >
    <div className="flex flex-col gap-1">
      <h2 className={`text-xl font-semibold ${colorScheme === 'dark' ? 'text-[#BEB9B9]' : 'text-[#0A0A0A]'}`}>
        {`Add Entry Price for ${tokenName}`}
      </h2>
      <p className="text-[14px] font-normal text-[#4A5565]">
        {`You have ${totalQuantity.toFixed(4)} ${tokenName} without entry price information. Split this into one
                  or more entries with their`}
        <br />
        respective entry prices.
      </p>
    </div>
    <div onClick={onClose}>
      <X
        size={24}
        className="text-[#99A1AF] !bg-none cursor-pointer"
      />
    </div>
  </div>
);

// Summary
const SummarySection = ({
  totalQuantity, allocated, remaining, colorScheme,
}) => (
  <div className={`w-full grid grid-cols-3 ${colorScheme === 'dark' ? 'bg-[#323438]' : 'bg-[#F9FAFB]'} gap-4 rounded-[14px] p-4`}>
    <div className="flex flex-col">
      <span className="text-sm text-[#4A5565] dark:text-gray-500">Total Quantity</span>
      <span className="text-2xl text-[#0A0A0A] dark:text-[#BEB9B9]">{totalQuantity.toFixed(4)}</span>
    </div>

    <div className="flex flex-col">
      <span className="text-sm text-[#4A5565] dark:text-gray-500">Allocated</span>
      <span className="text-2xl text-[#0A0A0A] dark:text-[#BEB9B9]">{allocated.toFixed(4)}</span>
    </div>

    <div className="flex flex-col">
      <span className="text-sm text-[#4A5565] dark:text-gray-500">Remaining</span>
      <span className="text-2xl text-[#E7000B]">{remaining.toFixed(4)}</span>
    </div>
  </div>
);

// AddEntryForm
const AddEntryForm = ({
  tokenName, form, setForm, liveTotalCost, isValidForm, addEntry, colorScheme, remaining,
}) => (
  <div className="w-full flex flex-col gap-3">
    <div className="text-lg font-semibold text-[#1C398E] dark:text-[#BEB9B9]">Add New Entry</div>
    <div className={`w-full px-5 py-4 gap-2.5 rounded-[10px] border ${colorScheme === 'dark' ? 'bg-[#26282C] border-[#898989]' : 'bg-[#F7FCFE] border-[#BEDBFF]'}`}>
      <div className="flex flex-col gap-[18px] items-start">
        <div className="grid grid-cols-3 gap-4 w-full">
          <div className="flex flex-col">
            <label className="text-sm text-[#364153] dark:text-[#BEB9B9] font-medium">{`Quantity of ${tokenName}`}</label>
            <input
              className="mt-2 border border-[#D1D5DC] rounded-[10px] px-3 py-2 text-sm"
              placeholder={`Max: ${remaining.toFixed(4)}`}
              type="text"
              value={form.quantity}
              onChange={(e) => {
                const val = e.target.value;

                // allow empty
                if (val === '') {
                  setForm((s) => ({ ...s, quantity: '' }));
                  return;
                }

                const regex = /^\d*\.?\d{0,8}$/;

                if (regex.test(val)) {
                  setForm((s) => ({ ...s, quantity: val }));
                }
              }}
            />
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-[#364153] dark:text-[#BEB9B9] font-medium">Entry Price (USD)</label>
            <input
              className="mt-2 border border-[#D1D5DC] rounded-[10px] px-3 py-2 text-sm"
              placeholder="0.0000"
              type="text"
              value={form.price}
              onChange={(e) => {
                const val = e.target.value;

                if (val === '') {
                  setForm((s) => ({ ...s, price: '' }));
                  return;
                }
                const regex = /^\d*\.?\d{0,8}$/;

                if (regex.test(val)) {
                  setForm((s) => ({ ...s, price: val }));
                }
              }}
            />
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-[#364153] dark:text-[#BEB9B9] font-medium">Total Cost</label>
            <div
              className={`mt-2 border rounded-[10px] ${colorScheme === 'dark' ? 'bg-[#2B2A29] border-gray-600 text-white' : 'border-[#D1D5DC] bg-[#F3F4F6] text-[#364153]'} px-3 py-2 text-sm flex items-center`}
            >
              {liveTotalCost || '—'}
            </div>
          </div>
        </div>
        <button
          className={`flex text-center text-base text-white gap-2 items-center justify-center py-2.5 self-stretch rounded-[10px] ${isValidForm ? 'bg-[#0072C3]' : (colorScheme === 'dark' ? 'text-gray-500 bg-[#3A3F47]' : 'bg-[#D1D5DC] cursor-not-allowed')}`}
          disabled={!isValidForm}
          onClick={addEntry}
          type="button"
        >
          <Plus size={16} />
          Add Entry
        </button>
      </div>
    </div>
  </div>
);

// Entry Table
const EntriesTable = ({
  entries, deleteEntry, colorScheme, showExistingWarning, isOverAllocated, isFullyAllocated,
}) => (
  <div className="w-full flex flex-col gap-3">
    <div className="text-base text-[#0A0A0A] dark:text-[#BEB9B9]">Entry Prices</div>
    <div className="w-full h-full flex flex-col items-start rounded-[10px] border border-[#E5E7EB] dark:border-[#898989] overflow-hidden">
      <div className={`w-full grid h-11 px-3.5 items-center border-b border-b-[#F3F4F6] dark:border-b-[#898989] ${styles.headingGrid}`}>
        <div className="text-sm text-[#4A5565] dark:text-[#BEB9B9] font-bold">Status</div>
        <div className="text-sm text-[#4A5565] dark:text-[#BEB9B9] font-bold">Quantity</div>
        <div className="text-sm text-[#4A5565] dark:text-[#BEB9B9] font-bold">Entry Price</div>
        <div className="text-sm text-[#4A5565] dark:text-[#BEB9B9] font-bold">Total Cost</div>
        <div className="text-sm text-[#4A5565] dark:text-[#BEB9B9] font-bold">Timestamp</div>
        <div className="flex justify-center text-sm text-[#4A5565] dark:text-[#BEB9B9] font-bold">Actions</div>
      </div>

      <div className={`w-full overflow-y-auto ${entries.length >= 4 ? 'max-h-[130px]' : ''} custom-scroll`}>
        {entries.map((entry) => (
          <div key={entry.id} className={`w-full grid h-11 px-3.5 items-center border-b border-b-[#F3F4F6] dark:border-b-[#898989] [&:last-child]:border-b-0 ${styles.rowGrid}`}>
            <div>
              {entry?.isNew ? (
                <div className="w-fit flex items-center justify-center py-0.5 px-2 bg-[#D9F2E2] rounded-[4px]">
                  <span className="text-[10px] text-[#009966]">New entry</span>
                </div>
              ) : (
                <div className="w-fit flex items-center gap-1 px-1.5 py-0.5 bg-[#FEF6E8] rounded-[4px]">
                  <AlertTriangle size={12} color="#F1A11A" />
                  <span className="text-[10px] text-[#F1A11A]">Pending</span>
                </div>
              )}
            </div>

            <div className="text-sm text-[#6A7282] dark:text-gray-500">{entry?.quantity}</div>
            <div className="text-sm text-[#6A7282] dark:text-gray-500">
              <Tooltip withArrow label={Number(entry.price).toFixed(4)}>
                <span>
                  {renderCompactNumber(entry.price, true)}
                </span>
              </Tooltip>
            </div>
            {/* <div className="text-sm text-[#6A7282] dark:text-gray-500">{renderNumber(entry.totalCost, true)}</div> */}
            {/* <div className="text-sm text-[#6A7282] dark:text-gray-500">{`$${entry.totalCost.toFixed(3)}`}</div> */}
            <div className="text-sm text-[#6A7282] dark:text-gray-500">
              <Tooltip withArrow label={Number(entry.totalCost).toFixed(4)}>
                <span>{renderNumber(entry.totalCost, true)}</span>
              </Tooltip>
            </div>
            <div className="text-sm text-[#4A5565] dark:text-gray-500">
              <Tooltip withArrow label={entry.timestamp}>
                <span>
                  {entry.timestamp?.length > 8 ? `${displayDate(entry.timestamp)?.slice(0, 13)}...` : entry.timestamp || '-'}
                </span>
              </Tooltip>
            </div>
            <div className="flex justify-center text-sm text-[#6A7282]">
              {entry?.isNew ? (
                <Trash size={16} className="text-red-500 cursor-pointer" onClick={() => deleteEntry(entry.userId)} />
              ) : (
                <i>Locked</i>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
    {showExistingWarning && <p className="text-xs font-normal text-[#6A7282]">Previously submitted cannot be modify</p>}
    {!isOverAllocated && isFullyAllocated && (
      <div className="flex items-center gap-1 px-[17px] py-3 bg-[#F0FDF4] rounded-[10px] border border-[#B9F8CF]">
        <Check size={22} color="#009966" />
        <p className="text-base font-normal text-[#009966]">All quantities have been allocated</p>
      </div>
    )}
  </div>
);

// Footer section
const FooterSection = ({
  footerMessage, disableSave, onCancel, onSaveClick, colorScheme,
}) => (
  <div className={`w-full flex justify-between items-center px-9 py-4 border-t rounded-b-2xl ${colorScheme === 'dark' ? 'bg-[#26282C] border-t-[#898989]' : 'bg-white border-t-[#E5E7EB]'}`}>
    <p className="text-sm text-[#4A5565] dark:text-gray-500">{footerMessage}</p>
    <div className="flex items-center gap-3">
      <button
        className={`px-6 py-2.5 border ${colorScheme === 'dark' ? 'border-[#898989] bg-[#26282C]' : 'border-[#D1D5DC] text-[#364153] bg-white'} rounded-[10px]`}
        onClick={onCancel}
        type="button"
      >
        Cancel
      </button>

      <button
        className={`px-6 py-2.5 rounded-[10px] text-white ${disableSave ? (colorScheme === 'dark' ? 'text-gray-500 bg-[#3A3F47]' : 'bg-[#D1D5DC]') : 'bg-[#33B1FF]'}`}
        onClick={onSaveClick}
        disabled={disableSave}
        type="button"
      >
        Save Entry Prices
      </button>
    </div>
  </div>
);

// WarningConfirmationModal
const WarningConfirmationModal = ({
  opened, onClose, onConfirm, colorScheme, saveState, onSuccess,
}) => {
  const statusLabel = {
    success: 'Success',
    error: 'Error',
    loading: 'Please wait...',
    warning: 'Warning!',
  }[saveState.status] || 'Warning!';
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      size="md"
      radius="md"
      padding={0}
      overlayProps={{ opacity: 0.35, blur: 2 }}
      styles={{
        modal: {
          backgroundColor: colorScheme === 'dark' ? '#2c2e33' : '#fff',
          borderRadius: '10px',
          width: 436,
          height: 309,
        },
      }}
    >
      <div
        className={`px-8 pt-[26px] pb-8 flex flex-col gap-2 items-center text-center ${saveState.status === 'loading' ? 'pb-4 justify-center h-[309px]' : ''}`}
      >
        {saveState.status === 'success' && (
          <Check size={48} color="#009966" />
        )}
        {saveState.status === 'loading' && (
          <Loader size="md" />
        )}

        {saveState.status === 'warning' && (
          <AlertIcon primaryFill="#F9A61A" secondaryFill="#F9A61A" primaryOpacity="0.40" />
        )}
        {saveState.status === 'error' && (
          <AlertIcon primaryFill="#fca5a5" secondaryFill="#ef4444" primaryOpacity="0.40" />
        )}
        <div className={`mt-2 p-3.5 text-[26px] font-semibold ${colorScheme === 'dark' ? 'text-[#898989]' : 'text-[#3A3A3A]'}`}>
          {statusLabel}
        </div>
        {saveState.status === 'loading' && (
          <div
            className="flex flex-col items-center justify-center gap-3 w-full"
          >
            <div className="font-medium text-[#4A5565] dark:text-[#BEB9B9]">
              while we are processing your request.
            </div>
          </div>
        )}

        {saveState.status === 'success' && (
          <div className="flex flex-col items-center gap-2">
            <div className="text-sm text-[#4A5565] dark:text-[#BEB9B9]">Your entries have been submitted.</div>
          </div>
        )}

        {saveState.status === 'error' && (
          <div className="flex flex-col items-center gap-2">
            <div className="font-medium text-[#E65353]">{saveState.message || 'Found error, please try again'}</div>
            <div className="text-sm text-[#4A5565] dark:text-[#898989]">You can close this dialog to retry or edit entries.</div>
          </div>
        )}
        {saveState.status === 'warning' && (
          <p className="text-sm text-[#4A5565] text-center">
            Once submitted, these entries cannot be modified or
            <br />
            deleted. Are you sure you want to proceed?
          </p>
        )}
        <div className={`w-full mt-8 gap-4 flex ${saveState.status === 'warning' ? 'justify-between' : 'justify-center'}`}>
          {saveState.status === 'warning' && (
            <>
              <button className="w-full px-[30px] py-[10px] rounded-md bg-[#E9EDF7] text-[#3A3A3A] font-semibold transition" onClick={onClose}>Cancel</button>
              <button className="w-full px-[30px] py-[10px] rounded-md bg-[#33B1FF] text-white font-semibold transition" onClick={onConfirm}>Confirm</button>
            </>
          )}

          {/* SUCCESS */}
          {saveState.status === 'success' && (
            <button
              className="w-fit px-[30px] py-[10px] rounded-md bg-[#33B1FF] text-white font-semibold transition"
              onClick={onSuccess}
            >
              OK
            </button>
          )}
          {/* ERROR */}
          {saveState.status === 'error' && (
            <button
              className="w-fit px-[30px] py-[10px] rounded-md bg-[#E9EDF7] text-[#3A3A3A] font-semibold transition"
              onClick={onClose}
            >
              Close
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

// Main Component
export default function AddEntryPriceModal({
  isOpen, setIsOpen, position, onSave, onClose, selectedPosition, saveState, setSaveState, sortedMissingEntries,
}) {
  const { colorScheme } = useMantineColorScheme();

  const totalQuantity = Number(selectedPosition?.quantity ?? 0);
  const tokenName = selectedPosition?.asset ?? '--';

  const [entries, setEntries] = useState([]);

  const [form, setForm] = useState({ quantity: '', price: '' });
  const [isWarningOpen, setIsWarningOpen] = useState(false);

  const modalRef = useClickOutside(() => {
    if (!isWarningOpen) setIsOpen(false);
  });

  // Load existing entries
  useEffect(() => {
    const mapped = mapRawEntries(sortedMissingEntries);
    setEntries(mapped);
  }, [selectedPosition]);

  // Live total cost
  const liveTotalCost = useMemo(() => {
    const cleanQty = form.quantity.replace(/[^\d.]/g, '');
    const cleanPrice = form.price.replace(/[^\d.]/g, '');

    const q = parseFloat(cleanQty);
    const p = parseFloat(cleanPrice);

    if (isNaN(q) || isNaN(p) || q <= 0 || p <= 0) return '';

    const total = q * p;
    return total.toFixed(4);
  }, [form.quantity, form.price]);

  // Allocated and remaining
  const allocated = useMemo(() => entries.reduce((sum, e) => sum + Number(e.quantity || 0), 0), [entries]);
  const remaining = useMemo(() => Number((totalQuantity - allocated).toFixed(4)), [totalQuantity, allocated]);

  // Validation pieces
  // const qty = useMemo(() => Number(Number(form.quantity || 0).toFixed(8)), [form.quantity]);
  const qty = useMemo(() => Number(form.quantity || 0), [form.quantity]);
  // const rem = useMemo(() => Number(Number(remaining || 0).toFixed(8)), [remaining]);
  const rem = useMemo(() => Number(remaining || 0), [remaining]);
  const isOverAllocated = qty > rem;
  const isFullyAllocated = rem === 0;

  const hasExisting = useMemo(() => entries.some((e) => !e.isNew), [entries]);
  const isValidForm = useMemo(() => qty > 0 && Number(form.price) > 0 && qty <= rem, [qty, form.price, rem]);
  const newCount = useMemo(() => entries.filter((e) => e.isNew).length, [entries]);

  const disableSave = useMemo(() => {
    if (entries.length === 0) return true;
    if (isFullyAllocated && hasExisting && newCount === 0) return true;
    if (hasExisting && newCount === 0 && !isFullyAllocated) return true;
    // at least one new entry
    return false;
  }, [entries.length, isFullyAllocated, hasExisting, newCount]);

  const footerMessage = useMemo(() => {
    if (entries.length === 0) return 'All entries must have both quantity and price.';
    if (newCount === 0) return 'No pending changes';
    return `${newCount} entry ready to submit`;
  }, [entries.length, newCount]);

  // Actions
  const addEntry = useCallback(() => {
    if (!isValidForm) return;
    const quantity = Number(form.quantity);
    const price = Number(form.price);
    // const totalCost = (quantity * price).toFixed(3);
    const totalCost = quantity * price;
    const newEntry = {
      userId: Date.now().toString(),
      isNew: true,
      quantity,
      price,
      totalCost,
      timestamp: new Date().toISOString(),
    };
    setEntries((prev) => [newEntry, ...prev]);
    setForm({ quantity: '', price: '' });
  }, [form, isValidForm]);

  const deleteEntry = useCallback((userId) => {
    setEntries((prev) => prev.filter((e) => e.userId !== userId));
  }, []);

  const handleSave = useCallback(() => {
    const newEntries = entries
      .filter((e) => e.isNew)
      .map((e) => ({
        quantity: e.quantity,
        entryPrice: e.price,
        positionId: selectedPosition?.positionId,
      }));

    onSave({
      token: tokenName,
      entryPrices: newEntries,
    });
  }, [entries, onSave, tokenName, selectedPosition]);

  const onConfirmSave = useCallback(() => {
    handleSave();
    // setIsWarningOpen(false);
    // setIsOpen(false);
  }, [handleSave]);

  const handleClose = () => {
    setIsWarningOpen(false);
    setTimeout(() => {
      setSaveState({ status: 'warning', message: '' });
    }, 200);
  };

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            ref={modalRef}
            className={`flex flex-col items-start pt-3 ${colorScheme === 'dark' ? 'bg-[#26282C]' : 'bg-white'} rounded-2xl shadow-xl w-[815px] max-h-[85vh]`}
          >
            <HeaderSection tokenName={tokenName} totalQuantity={totalQuantity} colorScheme={colorScheme} onClose={onClose} />

            <div className="custom-scrollbar-css w-full flex flex-col items-start gap-6 p-8 overflow-y-auto">
              <SummarySection totalQuantity={totalQuantity} allocated={allocated} remaining={remaining} colorScheme={colorScheme} />

              <AddEntryForm tokenName={tokenName} form={form} setForm={setForm} liveTotalCost={liveTotalCost} isValidForm={isValidForm} addEntry={addEntry} colorScheme={colorScheme} remaining={remaining} />

              {isOverAllocated && (
                <div className="flex w-full px-[17px] py-3 bg-[#FFEFEF] rounded-[10px] border border-[#FFCBCBE5]">
                  <p className="text-base font-normal text-[#E65353]">{`Total quantity would exceed remaining amount (${remaining.toFixed(4)} ${tokenName}) allocated`}</p>
                </div>
              )}

              {entries.length > 0 && (
                <EntriesTable entries={entries} deleteEntry={deleteEntry} colorScheme={colorScheme} showExistingWarning={hasExisting && !isFullyAllocated && !isOverAllocated} isOverAllocated={isOverAllocated} isFullyAllocated={isFullyAllocated} />
              )}
            </div>

            <FooterSection footerMessage={footerMessage} disableSave={disableSave} onCancel={onClose} onSaveClick={() => setIsWarningOpen(true)} colorScheme={colorScheme} />
          </div>
        </div>
      )}

      <WarningConfirmationModal
        opened={isWarningOpen}
        onClose={handleClose}
        onConfirm={onConfirmSave}
        onSuccess={() => {
          setIsOpen(false);
          setIsWarningOpen(false);
          setTimeout(() => {
            setSaveState({ status: 'warning', message: '' });
          }, 200);
        }}
        colorScheme={colorScheme}
        saveState={saveState}
      />
    </div>
  );
}
